module.exports = __webpack_public_path__ + "img/SW App book NUMERACY-min.bfe934e1.png";